var map = {
	"./icon-doc.png": 518,
	"./icon-docx.png": 519,
	"./icon-pdf.png": 524,
	"./icon-ppt.png": 522,
	"./icon-pptx.png": 523,
	"./icon-txt.png": 525,
	"./icon-xls.png": 520,
	"./icon-xlsx.png": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3571;